import CountBadge from '../ui/CountBadge';

/**
 * All / Unread / Read segmented tabs. Counts are live and always sum to the
 * total conversations in the current inbox.
 */
export default function FilterTabs({ tabs, activeTab, counts, onChange }) {
  return (
    <div
      role="tablist"
      aria-label="Filter conversations"
      className="flex items-stretch gap-0.5 border-b border-line px-2"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`relative flex flex-1 items-center justify-center gap-1.5 px-2 pt-2 pb-2.5 text-[13px] font-medium transition-colors ${
              isActive
                ? 'text-accent'
                : 'text-ink-2 hover:text-ink'
            }`}
          >
            {tab.label}
            <CountBadge value={counts[tab.id] ?? 0} tone={isActive ? 'soft' : 'neutral'} />

            {isActive && (
              <span
                aria-hidden="true"
                className="absolute inset-x-1.5 -bottom-px h-[2px] rounded-full bg-brand-600"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
